<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container equipment-wrapper">
  <h2>Equipment</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/equipment']">Equipment</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>
        <input matInput [(ngModel)]="searchEquipment" name="search"
          placeholder="Placeholder" />
      </mat-form-field>
    </div>
  </form>
  <div class="d-flex justify-content-start">
    <button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/equipment-form']">
      <mat-icon>add</mat-icon> New Equipment
    </button>
  </div>
  <div class="row">
    <div class="equipment-wrapper__item col-md-4 col-12 px-3 d-flex" *ngFor="let equipment of equipments | appFilter: searchEquipment;">
      <mat-card class="d-flex flex-column w-100">
        <div class="flex-grow-1">
          <h2 class="equipment-wrapper__item__title">
            {{ equipment.equipmentname }}
          </h2>
          <p class="equipment-wrapper__item__detail" style="font-weight:300;">
            {{ equipment.equipmentdescription }}<br />
          </p>
        </div>
        <button class="w-100" mat-flat-button color="accent" [routerLink]="['/view-equipment']"
          [queryParams]="{ id: equipment.equipment_id }">
          View Equipment
        </button>
      </mat-card>
    </div>
  </div>
</div>
